/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View } from 'react-native';
import TextView from '@airasia-phoenix/react-native/components/TextView';
import Link from './Link';
import {
  getColor,
  getTextStyle,
} from '@airasia-phoenix/react-native/utils/utils';
import { pd } from '@airasia-phoenix/react-native/utils';
import { StyleSheet } from 'react-native-unistyles';
import IconView from '@airasia-phoenix/react-native/components/IconView';
import { FooterConnectUs } from '../types';

interface ConnectWithUsProps {
  data: FooterConnectUs;
  openUrl: (url: string) => void;
  onLinkPress?: (sectionTitle: string, linkText: string) => void;
}

export const ConnectWithUs: React.FC<ConnectWithUsProps> = ({
  data,
  onLinkPress,
}) => {
  return (
    <View style={styles.socialSection}>
      <TextView
        text={data.title}
        style={getTextStyle(
          pd.sys.typescale.body_text,
          pd.sys.colour.content_primary,
        )}
      />
      <View style={styles.socialIconsContainer}>
        {data.icons.map((icon, index) => (
          <Link
            key={index}
            url={icon.url}
            boxShadowBorderRadius={16}
            onPress={() => onLinkPress?.('connect_with_us', icon.name)}
          >
            <IconView
              url={icon.icon}
              height={32}
              width={32}
              tint={getColor(pd.sys.colour.inline_white)}
            />
          </Link>
        ))}
      </View>
    </View>
  );
};

export default ConnectWithUs;

const styles = StyleSheet.create((pd) => ({
  socialSection: {
    // alignItems: 'flex-end',
  },
  socialIconsContainer: {
    flexDirection: 'row',
    gap: pd.ref.space.spacing40.px,
    marginTop: pd.ref.space.spacing10.px,
  },
}));
